import React, { useState } from "react";
import { Box, CardMedia, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import BrokenImageIcon from "@mui/icons-material/BrokenImage";

// Styled components
const FallbackContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius, // Add borderRadius from theme
  overflow: "hidden", // Ensure content doesn't overflow rounded corners
}));

const StyledBrokenImageIcon = styled(BrokenImageIcon)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

const CardMediaWithFallback = ({ image, alt, sx, ...props }) => {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
  };

  if (hasError) {
    return (
      <FallbackContainer>
        <StyledBrokenImageIcon />
        <Typography variant="body2" color="text.secondary">
          Sem imagem
        </Typography>
      </FallbackContainer>
    );
  }

  return (
    <CardMedia
      component="img"
      image={image}
      alt={alt}
      onError={handleError}
      sx={{
        objectFit: "cover",
        borderRadius: 2,
        ...sx,
      }}
      {...props}
    />
  );
};

// Example usage
const Card = ({ image, alt }) => {
  return <CardMediaWithFallback image={image} alt={alt} />;
};

export default Card;
